import { pluginFactory } from '@atlaskit/editor-common/utils';
import { PluginKey } from '@atlaskit/editor-prosemirror/state';
import reducer from '../reducer';
export var pluginKey = new PluginKey('expandPlugin');
var _pluginFactory = pluginFactory(pluginKey, reducer),
  createPluginState = _pluginFactory.createPluginState,
  createCommand = _pluginFactory.createCommand,
  getPluginState = _pluginFactory.getPluginState;
export { createPluginState, createCommand, getPluginState };